module.exports = __webpack_public_path__ + "img/fourtyoff.72db7fb7.png";